import { useColorScheme } from 'redesignedComponents/context/colorScheme';
import useStyles from './styles';

function TestimonialWithCardDesignAndTitleFallback() {
  const colorScheme = useColorScheme();
  const styles = useStyles({ colorScheme });

  return (
    <div className={styles.root} data-testid="testimonialFallback">
      <div className={styles.titleFallback}>
        <i className="skeleton" />
      </div>
      <div className={styles.carouselFallback}>
        <i className="skeleton" />
        <i className="skeleton" />
        <i className="skeleton" />
      </div>
    </div>
  );
}

export default TestimonialWithCardDesignAndTitleFallback;
